import React, { useEffect, useRef, useState } from 'react'

import { Link, Text } from '@cash-me/react-components'

import { ResendToken } from './styles'

type ResendTokenProps = {
  showComponent: boolean
  onResendTokenClick: () => void
}

export const ResentTokenComponent = ({ showComponent, onResendTokenClick }: ResendTokenProps) => {
  const [timer, setTimer] = useState<number>(30)
  const [shouldShowTimer, setShouldShowTimer] = useState<boolean>(true)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const startTimer = () => (intervalRef.current = setInterval(() => setTimer(prev => prev - 1), 1000))

  const handleResendTokenClick = () => {
    setTimer(30)
    setShouldShowTimer(true)
    return onResendTokenClick()
  }

  useEffect(() => {
    if (shouldShowTimer) startTimer()
    return () => clearInterval(intervalRef?.current as NodeJS.Timeout)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldShowTimer])

  useEffect(() => {
    if (timer <= 0) {
      setShouldShowTimer(false)
      clearInterval(intervalRef?.current as NodeJS.Timeout)
    }
  }, [timer])

  return (
    <>
      {showComponent && (
        <ResendToken>
          {shouldShowTimer ? (
            <Text size="caption">
              Para reenviar o código, espere <strong data-testid="timer">00:{timer > 9 ? timer : `0${timer}`}</strong>
            </Text>
          ) : (
            <Link onClick={handleResendTokenClick}>Reenviar código</Link>
          )}
        </ResendToken>
      )}
    </>
  )
}
